import { Toolbar, SaveButton } from 'react-admin'

export const DefaultToolbar = (props) => (
  <>
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  </>
)
